import {
    ADD_API_CLIENT_SUCCESS,
    DELETE_API_CLIENT_SUCCESS,
    FETCH_API_CLIENTS_SUCCESS,
    FETCH_MCP_CLIENTS_SUCCESS,
    UPDATE_API_CLIENT_SUCCESS,
    FETCH_API_CLIENT_SECRET_SUCCESS,
    ApiClientsActionType,
    HIDE_API_CLIENT_SECRET,
    ApiClientReducerActions,
} from '../actions/apiClientActions';
import { ApiClient, ClientSecret } from '../models/apiClient';

const MCP_INTEGRATION_TYPE = 'MCP';

export type ApiClientsState = {
    apiClients: ApiClient[];
    mcpClients: ApiClient[];
    clientSecret: ClientSecret | undefined;
};

const initialState: ApiClientsState = {
    apiClients: [],
    mcpClients: [],
    clientSecret: undefined,
};

const { UpdateApiClientActiveStateInit, FetchApiClientSecretInit } = ApiClientsActionType;

const replaceClientById = (clients: ApiClient[], updated: ApiClient): ApiClient[] => {
    const index = clients.findIndex(client => client.id === updated.id);
    if (index === -1) return clients;
    const copy = [...clients];
    copy[index] = updated;
    return copy;
};

export default (state: ApiClientsState = initialState, action: ApiClientReducerActions): ApiClientsState => {
    switch (action.type) {
        case FETCH_API_CLIENTS_SUCCESS:
            return {
                ...state,
                apiClients: action.apiClients,
            };
        case FETCH_MCP_CLIENTS_SUCCESS:
            return {
                ...state,
                mcpClients: action.mcpClients,
            };
        case UpdateApiClientActiveStateInit:
            return {
                ...state,
                apiClients: replaceClientById(state.apiClients, action.apiClient),
                mcpClients: replaceClientById(state.mcpClients, action.apiClient),
            };
        case UPDATE_API_CLIENT_SUCCESS:
            return {
                ...state,
                apiClients: action.apiClient ? replaceClientById(state.apiClients, action.apiClient) : state.apiClients,
                mcpClients: action.apiClient ? replaceClientById(state.mcpClients, action.apiClient) : state.mcpClients,
            };
        case ADD_API_CLIENT_SUCCESS:
            return {
                ...state,
                apiClients:
                    action.apiClient.integrationType === MCP_INTEGRATION_TYPE
                        ? state.apiClients
                        : [...state.apiClients, action.apiClient],
                mcpClients:
                    action.apiClient.integrationType === MCP_INTEGRATION_TYPE
                        ? [...state.mcpClients, action.apiClient]
                        : state.mcpClients,
            };
        case DELETE_API_CLIENT_SUCCESS:
            return {
                ...state,
                apiClients: state.apiClients.filter(client => client.id !== action.clientId),
                mcpClients: state.mcpClients.filter(client => client.id !== action.clientId),
            };
        case FetchApiClientSecretInit:
            return {
                ...state,
                clientSecret: undefined,
            };
        case FETCH_API_CLIENT_SECRET_SUCCESS:
            return {
                ...state,
                clientSecret: action.secret,
            };
        case HIDE_API_CLIENT_SECRET:
            return {
                ...state,
                clientSecret:
                    state.clientSecret && state.clientSecret.clientId === action.clientId
                        ? undefined
                        : state.clientSecret,
            };
        default:
            return state;
    }
};
